<template>
  <header class="ren-decoration-cp ren-decoration-cp-content-header">
    <div>
      <strong>{{ brandName }}</strong>
      <span v-if="subtitle">{{ subtitle }}</span>
    </div>
    <p v-if="showSearch" class="ren-decoration-cp-content-header__search">{{ searchPlaceholder }}</p>
    <nav v-if="showChannels">
      <span v-if="channels.length === 0">暂无频道</span>
      <span v-for="(item, index) in channels" :key="index">{{ item }}</span>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, previewRecordsFor, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const brandName = computed(() => stringValue(props.component.props?.brandName, '内容频道'))
const subtitle = computed(() => stringValue(props.component.props?.subtitle))
const showSearch = computed(() => booleanValue(props.component.props?.showSearch, true))
const searchPlaceholder = computed(() => stringValue(props.component.props?.searchPlaceholder, '搜索'))
const showChannels = computed(() => booleanValue(props.component.props?.showChannels, true))
const channels = computed(() =>
  previewRecordsFor(props.component, props.componentData)
    .map((item) => stringValue(item.name ?? item.title ?? item.label))
    .filter(Boolean)
    .slice(0, 8)
)
</script>

<style scoped>
.ren-decoration-cp-content-header {
  display: grid;
  gap: 8px;
}
.ren-decoration-cp-content-header span,
.ren-decoration-cp-content-header p {
  color: var(--ren-theme-muted);
  font-size: 12px;
  margin: 0;
}
.ren-decoration-cp-content-header nav {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
